var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.75 475.584L378.411 348.245C413.112 305.805 430.174 251.65 426.066 196.983C421.959 142.315 396.997 91.318 356.343 54.5391C315.69 17.7602 262.455 -1.98631 207.651 -0.616033C152.847 0.754247 100.666 23.1365 61.9011 61.9011C23.1365 100.666 0.754247 152.847 -0.616033 207.651C-1.98631 262.455 17.7602 315.69 54.5391 356.343C91.318 396.997 142.315 421.959 196.983 426.066C251.65 430.174 305.805 413.112 348.245 378.411L475.584 505.75C479.608 509.636 484.997 511.786 490.59 511.737C496.184 511.689 501.534 509.445 505.49 505.49C509.445 501.534 511.689 496.184 511.737 490.59C511.786 484.997 509.636 479.608 505.75 475.584ZM213.333 384C179.579 384 146.582 373.991 118.516 355.238C90.45 336.485 68.5753 309.83 55.6579 278.645C42.7405 247.459 39.3608 213.144 45.946 180.038C52.5312 146.932 68.7856 116.522 92.6538 92.6538C116.522 68.7856 146.932 52.5312 180.038 45.946C213.144 39.3608 247.459 42.7405 278.645 55.6579C309.83 68.5753 336.485 90.45 355.238 118.516C373.991 146.582 384 179.579 384 213.333C383.949 258.581 365.952 301.962 333.957 333.957C301.962 365.952 258.581 383.949 213.333 384Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.b748203489a9772f9d18a6879741210b.svg";
export { ForwardRef as ReactComponent };